import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../context/AuthContext'
import './onboarding/onboarding.css'
import './settings/settings.css'

/**
 * Экран Settings по ТЗ 25.3.
 * Пункты: Email notifications, Subscriptions, Account & password, Legal, Privacy, Info, Log out.
 */
const ProfileSettings = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { signOut } = useAuth()
  const [showLogoutModal, setShowLogoutModal] = useState(false)

  const items = [
    { key: 'notifications', label: t('settings.emailNotifications') },
    { key: 'subscriptions', label: t('settings.subscriptions') },
    { key: 'account', label: t('settings.account') },
    { key: 'language', label: t('settings.language') },
    { key: 'legal', label: t('settings.legal') },
    { key: 'privacy', label: t('settings.privacy') }
  ]

  const onBack = () => navigate('/app/profile')
  const onItem = (key) => navigate(`/app/profile/settings/${key}`)
  const onLogoutClick = () => setShowLogoutModal(true)
  const onLogoutConfirm = async () => {
    await signOut()
    navigate('/', { replace: true })
    window.location.reload()
  }

  return (
    <div className="onboarding-page">
      <div className="onboarding-content" style={{ paddingTop: 48, paddingBottom: 80 }}>
        <div style={{ marginBottom: 24 }}>
          <button type="button" className="link" onClick={onBack}>← {t('common.back')}</button>
        </div>
        <h1 className="h1">{t('settings.title')}</h1>
        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
          {items.map((item) => (
            <li key={item.key}>
              <button type="button" className="settings-list-item" onClick={() => onItem(item.key)}>
                {item.label}
              </button>
            </li>
          ))}
          <li>
            <button
              type="button"
              className="settings-list-item"
              style={{ color: 'var(--red, #c00)' }}
              onClick={onLogoutClick}
            >
              {t('settings.logOut')}
            </button>
          </li>
        </ul>
      </div>

      {showLogoutModal && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(0,0,0,0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
            padding: 24
          }}
          onClick={() => setShowLogoutModal(false)}
        >
          <div
            style={{
              background: 'var(--white, #fff)',
              borderRadius: 16,
              maxWidth: 320,
              width: '100%',
              padding: 24
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <p className="p" style={{ marginBottom: 24 }}>{t('settings.logoutConfirm')}</p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              <button
                type="button"
                style={{
                  padding: '14px 24px',
                  borderRadius: 50,
                  fontSize: 16,
                  cursor: 'pointer',
                  border: 'none',
                  background: 'var(--light-gray, #eee)',
                  color: 'var(--black, #000)'
                }}
                onClick={() => setShowLogoutModal(false)}
              >
                {t('common.close')}
              </button>
              <button
                type="button"
                style={{
                  padding: '14px 24px',
                  borderRadius: 50,
                  fontSize: 16,
                  cursor: 'pointer',
                  background: 'transparent',
                  color: '#c00',
                  border: '1px solid #c00'
                }}
                onClick={onLogoutConfirm}
              >
                {t('settings.logOut')}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default ProfileSettings
